export default "__VITE_ASSET__f0557e64__"